import type { AgentInstallCommand } from './types.js';
import { runNpmGlobalInstall } from './run-npm-global-install.js';

export const codexAcpInstallCommand: AgentInstallCommand = {
  agentType: 'codex-acp',
  detectCommand: 'codex',
  async install(ctx) {
    const logOutput = await runNpmGlobalInstall('@openai/codex', {
      ...ctx.env,
      OPENAI_API_KEY: ctx.authToken,
    });
    ctx.onProgress?.('Installing Codex', logOutput || undefined);
  },
};
